<template>
  <b-alert :show="show" variant="danger" dismissible class="alert-danger" @dismissed="errosTemp=[]">
    <h5>Erro(s):</h5>
    <ul>
      <li v-for="erro in errosTemp" :key="erro">{{ erro }}</li>
    </ul>
  </b-alert>
</template>

<script>
export default {
  props: {
    erros: {
      type: Array,
      default: ''
    }
  },
  data () {
    return {
      errosTemp: []
    }
  },
  computed: {
    show () {
      return this.errosTemp.length > 0
    }
  },
  watch: {
    erros () {
      this.errosTemp = this.erros
    }
  },
  created () {
    this.errosTemp = this.erros
  }
}
</script>
